angular.module('TetherApp').directive('tetherRadio', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherRadio.html'
    }
});
